export interface IFilter {
  label: string;
  values?: IFilterValue[];
  action?: (filterValue: string) => any | undefined;
  type: FilterType;
  propname: string;
  minWidth?: number;
  optionsLoader?: () => Promise<IFilterValue[]>;
}

export interface IFilterValue {
  key: string;
  val: any;
}

export enum FilterType{
  multiselect = 1,
  date = 2,
  dateRange = 3,
  select = 4,
  text = 5,
  ageRange = 6,
  checkbox = 7
}